var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5085 3.4871C24.5326 -0.489841 18.0622 -0.489841 14.0843 3.4871L13.847 3.72443C13.261 4.31042 13.261 5.25973 13.847 5.84572C14.433 6.43171 15.3823 6.43171 15.9683 5.84572L16.2056 5.60839C19.0135 2.80051 23.5813 2.80246 26.3872 5.60839C27.7496 6.97082 28.4997 8.77861 28.4997 10.6997C28.4997 12.6198 27.7496 14.4276 26.3872 15.79L26.1499 16.0273C25.5639 16.6133 25.5639 17.5626 26.1499 18.1486C26.4429 18.4416 26.8267 18.5881 27.2105 18.5881C27.5944 18.5881 27.9782 18.4416 28.2712 18.1486L28.5085 17.9113C30.4374 15.9824 31.5 13.4216 31.5 10.6997C31.5 7.97775 30.4374 5.41599 28.5085 3.4871ZM16.023 26.1543L15.7856 26.3916C12.9787 29.1985 8.4109 29.1985 5.60399 26.3916C2.79708 23.5847 2.79708 19.0169 5.60399 16.21L5.84132 15.9726C6.42731 15.3867 6.42731 14.4374 5.84132 13.8514C5.25533 13.2654 4.30602 13.2654 3.72003 13.8514L3.4827 14.0887C-0.494235 18.0656 -0.494235 24.536 3.4827 28.5129C5.47117 30.5014 8.08274 31.4956 10.6948 31.4956C13.3069 31.4956 15.9185 30.5014 17.9069 28.5129L18.1443 28.2756C18.7302 27.6896 18.7302 26.7403 18.1443 26.1543C17.5583 25.5683 16.6089 25.5683 16.023 26.1543Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1005 9.77385L9.76945 20.1049C9.18346 20.6909 9.18346 21.6402 9.76945 22.2262C10.0624 22.5192 10.4463 22.6657 10.8301 22.6657C11.2139 22.6657 11.5977 22.5192 11.8907 22.2262L22.2218 11.8951C22.8078 11.3091 22.8078 10.3598 22.2218 9.77385C21.6358 9.18786 20.6865 9.18785 20.1005 9.77385Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic_link.ad27ade4322116178a9a7deb3c1bf0a4.svg";
export { ForwardRef as ReactComponent };